// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__1majA","content":"Desktop_content__1HLmR"};